import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Comment, Params } from './types'
import { RequestError } from '../../../shared/errorResponse'

export const commentListMounted = createEvent<Params>()
export const commentListBackendUpdated = createEvent<Params>()
export const deleteComment = createEvent<{ id: string }>()

export const getCommentsFailed = createEvent<RequestError | null>()

export const $commentsError = restore<RequestError | null>(
  getCommentsFailed,
  null,
).reset([commentListMounted])

export const getComments = fx<Params, Comment[]>({
  method: 'GET',
  url: `/comment?where={"entityType":"client"}`,
})

export const deleteCommentRequest = fx<{ id: string }, Comment>({
  method: 'DELETE',
  url: `/comment`,
})

export const $comments = restore<Comment[]>(
  getComments.doneData.map((a) => a.body),
  [],
)

sample({
  clock: commentListMounted,
  fn: ({ entityType, entityId }) => {
    return {
      url: `/comment?where={"entityType":"${entityType}", "entityId":"${entityId}"}`,
    }
  },
  target: getComments,
})

sample({
  clock: deleteComment,
  fn: ({ id }) => {
    return {
      url: `/comment/${id}`,
    }
  },
  target: deleteCommentRequest,
})

sample({
  // @ts-ignore
  clock: deleteCommentRequest.doneData,
  fn: (doneData) => ({
    entityType: doneData.body.entityType,
    entityId: doneData.body.entityId,
  }),
  target: commentListBackendUpdated,
})

getComments.fail.watch(({ error }) =>
  getCommentsFailed({ code: error.status, message: error.body.message }),
)

getComments.done.watch(() => getCommentsFailed(null))

export const getCommentsByTypes = fx<void, Comment[]>({
  method: 'GET',
  url: `/comment`,
})
